import React from 'react';

export default (WrappedComponent) => {
  const BreakPoint = {
    tablet:  768,
    desktop: 1000
  };

  return class withDeviceHOC extends React.Component {
    componentDidMount () {
      window.addEventListener('resize', this.onResize, false);
    }

    componentWillUnmount () {
      window.removeEventListener('resize', this.onResize, false);
    }

    isMobile = () => {
      return window.innerWidth < BreakPoint.tablet;
    };

    isTablet = () => {
      return (
        window.innerWidth >= BreakPoint.tablet &&
        window.innerWidth < BreakPoint.desktop
      );
    };

    onResize = () => {
      this.setState({
        isMobile: this.isMobile(),
        isTablet: this.isTablet()
      });
    };

    state = {
      isMobile: this.isMobile(),
      isTablet: this.isTablet()
    };

    render () {
      return (
        <WrappedComponent
          {...this.props}
          isMobile={this.state.isMobile}
          isTablet={this.state.isTablet}
        />
      );
    }
  };
};



// WEBPACK FOOTER //
// ./frontend/react/components/common/withDeviceHOC/index.js